import type { GraphQLError } from 'graphql';

export const TRIAL_SESSION_COOKIE = 'trial_session';
export const TRIAL_USER_HEADER = 'x-askable-trial-user' as const;
export const TRIAL_COOKIE_REVOKED_EVENT = 'trial-cookie-revoked';

type AuthHeaders = { readonly Authorization: string } | { readonly [TRIAL_USER_HEADER]: string } | undefined;

export function resolveAuthHeaders(token: string | undefined, trialCookie: string | undefined): AuthHeaders {
  if (token) {
    return { Authorization: token };
  }

  if (trialCookie) {
    return { [TRIAL_USER_HEADER]: trialCookie };
  }

  return undefined;
}

export function shouldAuthError(token: string | undefined, trialCookie: string | undefined): boolean {
  return !token && !trialCookie;
}

export function isAuthExpiredError(error: GraphQLError): boolean {
  return error.extensions?.code === 401 || error.message === 'invalid token' || error.message === 'jwt expired';
}
